module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-id-2.31da8277.png";